import { gql } from "apollo-boost";


export const GET_EXCHANGRATE = gql`
query ExchangeRate($where: ExchangeRateWhereInput) {
  exchangeRate(where: $where) {
    kip
    baht
    usd
    id
    updatedAt
    createdAt
  }
}
`

export const GET_ALL_SUM_ORDER = gql`
query ReportAllSumOrder($where: ReportWhereInput!) {
  reportAllSumOrder(where: $where) {
    totalPrice
    productAmount
    billAmount
    sumPriceUsd
    sumPriceBaht
  }
}
`

export const GET_REPORT_BESTSALE = gql`
query ReportBestSeller($where: ReportWhereInput!, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  reportBestSeller(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    data {
      productName
      amount
      category
      brand
      unit
      totalPrice
      currency
    }
  }
}
`